// extracted by mini-css-extract-plugin
module.exports = {"pay_main":"PayResult_pay_main__3PvsS","main":"PayResult_main__29vmA"};